/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const bus_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.4 20.067v1.466a1.467 1.467 0 1 0 2.933 0v-1.466m-2.933 0h13.2m-13.2 0A1.467 1.467 0 0 1 3.933 18.6V5.4a4.4 4.4 0 0 1 4.4-4.4h7.334a4.4 4.4 0 0 1 4.4 4.4v13.2a1.467 1.467 0 0 1-1.467 1.467m0 0v1.466a1.466 1.466 0 1 1-2.933 0v-1.466M9.8 3.933h4.4m-7.333 13.2H9.8m4.4 0h2.933m-13.2-8.8H2.467A1.467 1.467 0 0 0 1 9.8v4.4m19.067-5.867h1.466A1.467 1.467 0 0 1 23 9.8v4.4M3.933 6.867h16.134V14.2H3.933V6.867Z"
    />
  </svg>
)
export default bus_medium
